import { QUIZ, QUIZ_QUESTION } from "~/consts";

export default {
  computed: {
    canAccessQuizResult() {
      return !this.isEmpty(this.auth.activeAccount) && this.auth.activeAccount.permissionNames.includes("can_access_quiz_result") === true;
    },
  },

  data() {
    return {
      loading_get_member_answers: false,
      loading_get_questions: false,
      loading_download_example_import_file: false,
      loading_get_quiz_ranks: false,
      loading_get_quiz_ranks_refresh: false,
      loading_get_result: false,
      quizRankDataProvider: {
        page: {
          current: 1,
          limit: 5
        }
      },
      quiz_ranks: []
    }
  },

  methods: {
    onSavedQuiz(data) {},
    updateQuiz(id, data) {
      this.$axios
        .post(QUIZ.SAVE(id), data)
        .then(({ data }) => {
          if (data.applicationSystem.code == 0) {
            this.onSavedQuiz(data.data);
          } else {
            toast.danger(data.applicationSystem.message);
          }
        })
        .catch(() => {});
    },

    onGetRankSuccess() {},
    onGetRankFailed() {},
    getRank(id) {
      const vm = this;

      this.$axios
        .post(QUIZ.GET_RANK(id))
        .then(({ data }) => {
          if (data.applicationSystem.code == 0) {
            vm.onGetRankSuccess(data);
          } else {
            vm.onGetRankFailed(data);
          }
        })
        .catch(() => {
          vm.onGetRankFailed();
        });
    },

    onGetMemberAnswersSuccess() {},
    onGetMemberAnswersFailed() {},
    getMemberAnswers(quiz_id, qm_id) {
      const vm = this;

      this.loading_get_member_answers = true

      this.$axios
        .post(QUIZ.GET_MEMBER_ANSWERS(quiz_id), {
          qm_id,
        })
        .then(({ data }) => {
          if (data.applicationSystem.code == 0) {
            vm.onGetMemberAnswersSuccess(data);
          } else {
            vm.onGetMemberAnswersFailed(data);
          }

          this.loading_get_member_answers = false
        })
        .catch(() => {
          vm.onGetMemberAnswersFailed();

          this.loading_get_member_answers = false
        });
    },

    onGetQuizQuestionsSuccess() {},
    onGetQuizQuestionsFailed() {},
    getQuizQuestions(id) {
      const vm = this;

      vm.loading_get_questions = true;

      this.$axios.post(QUIZ_QUESTION.GET_ALL(id))
        .then(({ data }) => {
          if (data.applicationSystem.code == 0) {
            vm.onGetQuizQuestionsSuccess(data);
          } else {
            vm.onGetQuizQuestionsFailed(data);
          }

          vm.loading_get_questions = false;
        }).catch(() => {
          vm.onGetQuizQuestionsFailed();
          vm.loading_get_questions = false;
        });
    },

    onDownloadExampleImportFileSuccess(downloadUrl) {
      window.open(downloadUrl, "_blank");
    },
    onDownloadExampleImportFileFailed(msg = '') {
      toast.danger(msg);
    },
    downloadExampleImportFile(ext) {
      const vm = this;

      vm.loading_download_example_import_file = true;

      this.$axios.post(QUIZ_QUESTION.DOWNLOAD_EXAMPLE_IMPORT, {ext})
        .then(({ data }) => {
          if (data.applicationSystem.code == 0) {
            vm.onDownloadExampleImportFileSuccess(data.data.downloadUrl);
          } else {
            vm.onDownloadExampleImportFileFailed(data.applicationSystem.message);
          }

          vm.loading_download_example_import_file = false;
        }).catch(() => {
          vm.onDownloadExampleImportFileFailed();
          vm.loading_download_example_import_file = false;
        });
    },

    onGetPaginatedQuizRankSuccess() {},
    onGetPaginatedQuizRankFailed() {},
    getPaginatedQuizRank(id, refresh = false) {
      const vm = this

      if (refresh) {
        this.quizRankDataProvider.page['current'] = 1
        this.loading_get_quiz_ranks_refresh = true
      } else {
        vm.loading_get_quiz_ranks = true
      }


      this.$axios.post(QUIZ.GET_PAGINATED_RANK(id), {
        dataProvider: JSON.stringify(vm.quizRankDataProvider)
      })
        .then(({ data }) => {
          if (data.applicationSystem.code == 0) {
            vm.onGetPaginatedQuizRankSuccess(data, refresh)
          } else {
            vm.onGetPaginatedQuizRankFailed(data, refresh);
          }

          vm.loading_get_quiz_ranks = false
          vm.loading_get_quiz_ranks_refresh = false
        }).catch(() => {
          vm.loading_get_quiz_ranks = false
          vm.loading_get_quiz_ranks_refresh = false
        })
    },

    async getQuizResult(quiz_id, quiz_member_id) {
      this.loading_get_result = true
      let token = this.$route.params.token;
      token = this.isEmpty(token) ? this.$cookies.get('token') : token;

      if (token) {
        let no_need_encode = false;
        try {
          no_need_encode = helpers.parseJwt(token)
          no_need_encode = !helpers.isEmpty(no_need_encode) && !helpers.isEmpty(no_need_encode.username) && !helpers.isEmpty(no_need_encode.appid)
        } catch (e) {
        }
        token = no_need_encode ? token : helpers.encodeToken(token)
      }

      if (this.isEmpty(token)) {
        this.$nuxt.error({ message: "Data tidak ditemukan", statusCode: 404 });
        return null;
      }

      try {
        let { data } = await axios
          .post(
            `${process.env.API_URL}${QUIZ.GET_MY_RANK(quiz_id)}`,
            {
              qmid: quiz_member_id
            },
            {
              headers: {
                "Content-type": "application/json",
                'Authorization': `Bearer ${token}`
              },
            })
        if (data.applicationSystem.code == 0) {
          return data.data[0];
        }
        return null;
      } catch ({ response }) {
        return null;
      }
    },

    validateQuizQuestion(quiz, question) {
      if (question.body.match('<img src="data:image')) {
        toast.danger(`Pertanyaan tidak dapat disimpan karena terdapat gambar yang tidak kompatibel, silakan pilih gambar dari fitur Media Library`);
        return true;
      }

      let question_media_ids = question.media_ids;
      if (this.isEmpty(question_media_ids)) {
        question_media_ids = question.medias;
      }
      if (this.isEmpty(question.body.match('<img')) && this.isEmpty(this.strip_tags(question.body)) && this.isEmpty(question_media_ids)) {
        toast.danger(`Pertanyaan no. ${question.order + 1} harus diisi`);
        return true;
      }

      if (quiz.type == 0) {
        if (question.score > 1000) {
          toast.danger(`Bobot pertanyaan no. ${question.order + 1} maksimal adalah 1000`);
          return true;
        }
        if (this.isEmpty(question.score) || question.score <= 0) {
          toast.danger(`Bobot pertanyaan no. ${question.order + 1} harus diisi minimal 1`);
          return true;
        }
      }

      if (this.isEmpty(question.answers)) {
        toast.danger(`Pilihan jawaban pada pertanyaan no. ${question.order + 1} harus diisi minimal 2`);
        return true;
      }

      if (question.answers.length < 2) {
        toast.danger(`Pilihan jawaban pada pertanyaan no. ${question.order + 1} harus diisi minimal 2`);
        return true;
      }

      const questionTrueAnswers = question.answers.filter(answer => answer.isCorrect === true);
      if (questionTrueAnswers.length === 0) {
        toast.danger(`Tentukan jawaban benar pada pertanyaan no. ${question.order + 1}`);
        return true;
      }

      const isAnyEmptyAnswer = question.answers.some(answer => {
        if (answer.body.match('<img src="data:image')) {
          toast.danger(`Pilihan jawaban tidak dapat disimpan karena terdapat gambar yang tidak kompatibel, silakan pilih gambar dari fitur Media Library`);
          return true;
        }

        if (this.isEmpty(answer.body.match('<img')) && this.isEmpty(this.strip_tags(answer.body))) {
          toast.danger("Pilihan jawaban harus diisi");
          return true;
        }
      })
      if (isAnyEmptyAnswer) {
        return true;
      }

      return false;
    },

    proctoringCheatDetection(proctoring) {
      const cheatByFaceCount = proctoring.faceCount > 1;

      const faceDetectionTotal = proctoring.faceDetectCount + proctoring.faceUndetectCount;
      const facePresence = (proctoring.faceDetectCount / faceDetectionTotal) * 100;
      const cheatByFacePresence = facePresence < 50;

      const cheatByUnfocusScreen = proctoring.unfocusScreenCount > 10;

      return {
        isCheating: cheatByFaceCount || cheatByFacePresence || cheatByUnfocusScreen,
        cheatByFaceCount,
        cheatByFacePresence,
        cheatByUnfocusScreen,
        facePresence: facePresence.toFixed(2),
      };
    }
  },
};
